import { render, staticRenderFns } from "./customer-groups-grid.vue?vue&type=template&id=114c790a&"
import script from "./customer-groups-grid.ts?vue&type=script&lang=ts&"
export * from "./customer-groups-grid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports